import { useContext, useEffect } from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import PropTypes from 'prop-types';

import RichText from '../../Core/RichText';
import Link from '../../Core/Link';
import { Context } from '../../Providers/Blade';
import SubMenu from '../../Core/Submenu';

import { Links, MenuFooter, StyledCtas } from './styles';

const link = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
  },
};

const MainMenu = ({ data }) => {
  const { navigationTabs, brandLogoDam, searchFieldText, ctas } = data;

  // Bring in Blade context so we can close the blade if the current page url is passed
  const { resetState } = useContext(Context);
  useEffect(() => resetState(), []);

  return (
    <>
      {navigationTabs && (
        <Links className="no-bullets">
          {navigationTabs.map((cta, idx) => {
            const {
              id,
              dropdownToggle,
              ctas: navCtas,
              navigationHeading,
            } = cta;
            return dropdownToggle ? (
              <li key={id}>
                <SubMenu
                  navCtas={navCtas}
                  ctas={ctas}
                  logo={brandLogoDam}
                  searchFieldText={searchFieldText}
                  navHeader={navigationHeading}
                  positionIdx={idx}
                />
              </li>
            ) : (
              <li key={id}>
                <Link
                  className="unstyled-link nav-tab"
                  data={navCtas[0]}
                  blade
                  resetState={resetState}
                >
                  <RichText document={navCtas[0].label} options={link} />
                </Link>
              </li>
            );
          })}
        </Links>
      )}
      {ctas && (
        <MenuFooter>
          <StyledCtas ctas={ctas} direction="row" />
        </MenuFooter>
      )}
    </>
  );
};

MainMenu.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default MainMenu;
